import React, { useState, useEffect, useCallback } from 'react';
import Landing from './components/Landing';
import CropasaurusApp from './components/CropasaurusApp';
import FlowerLab from './components/FlowerLab';
import PinGate from './components/PinGate';

// Tiny hash-based router so /#app deep-links straight into the tool and the
// back button still moves between Landing <-> App <-> Lab. No router library.
//   #app  → CropasaurusApp
//   #lab  → Private Flower Lab (PIN-gated)
//   else  → Landing
export default function App() {
  const readHash = () => {
    const h = typeof window !== 'undefined' ? window.location.hash : '';
    if (h === '#app') return 'app';
    if (h === '#lab') return 'lab';
    return 'landing';
  };
  const [view, setView] = useState(readHash);
  const [labUnlocked, setLabUnlocked] = useState(false);
  const [pinOpen, setPinOpen] = useState(false);

  useEffect(() => {
    function onHash() { setView(readHash()); }
    window.addEventListener('hashchange', onHash);
    return () => window.removeEventListener('hashchange', onHash);
  }, []);

  // If user lands on #lab directly and isn't unlocked yet → show pin gate
  useEffect(() => {
    if (view === 'lab' && !labUnlocked) {
      setPinOpen(true);
    }
  }, [view, labUnlocked]);

  const goToApp = useCallback(() => {
    window.location.hash = '#app';
    setView('app');
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, []);

  const requestLab = useCallback(() => {
    setPinOpen(true);
  }, []);

  const onPinUnlock = useCallback(() => {
    setLabUnlocked(true);
    setPinOpen(false);
    window.location.hash = '#lab';
    setView('lab');
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, []);

  const exitLab = useCallback(() => {
    setLabUnlocked(false);
    window.location.hash = '#app';
    setView('app');
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, []);

  return (
    <>
      {view === 'landing' && <Landing onStart={goToApp} />}
      {view === 'app' && <CropasaurusApp onSecretLab={requestLab} />}
      {view === 'lab' && labUnlocked && <FlowerLab onExit={exitLab} />}
      {view === 'lab' && !labUnlocked && (
        // While the pin gate is up, render the cropasaurus app behind it so
        // a wrong PIN / closed dialog has a sensible background to fall back to.
        <CropasaurusApp onSecretLab={requestLab} />
      )}
      {pinOpen && (
        <PinGate
          onUnlock={onPinUnlock}
          onClose={() => {
            setPinOpen(false);
            if (view === 'lab') {
              window.location.hash = '#app';
              setView('app');
            }
          }}
        />
      )}
    </>
  );
}
